export default __webpack_public_path__ + "static/media/Degraded Shockwave.ea751db2.png";